// removed by extract-text-webpack-plugin
module.exports = {"main_right_content":"components-tjcx-zytzxx-index-main_right_content-2sFdv","table":"components-tjcx-zytzxx-index-table-3LYFG"};


//////////////////
// WEBPACK FOOTER
// ./components/tjcx/zytzxx/index.css
// module id = 568
// module chunks = 0